export default __webpack_public_path__ + "static/media/preprint_Tseng_et_al_2026_biorxiv.59a40ead.pdf";